import baseAPI from '@/http'

const router = 'api/salaindicadorfonte'

export const salaIndicadorFonte = {
  create: (fonte) => baseAPI.post(router, fonte),
  update: (fonte) => baseAPI.put(router, fonte),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`)
}
